// extracted by mini-css-extract-plugin
module.exports = {"Table":"Table_Table__E3A4E","TableStyled":"Table_TableStyled__HEFTb","TableCell":"Table_TableCell__BhqNg"};